import { AssetServiceLogCreateRequestCalibrationKind } from 'generatedTypes/asset/models';

export const CALIBRATION_KIND_ORDER = [
    AssetServiceLogCreateRequestCalibrationKind.PUMP,
    AssetServiceLogCreateRequestCalibrationKind.FLOW,
    AssetServiceLogCreateRequestCalibrationKind.WEIGHT,
    AssetServiceLogCreateRequestCalibrationKind.MAGNETOMETER,
    AssetServiceLogCreateRequestCalibrationKind.LEVEL
];

export const TEST_ID = 'calibrationKindSelectPanelField';
